import React, { Component } from "react";
import { Form, Step, Segment, Header, Container, Button, Message, Icon, Tab, Divider, Label, Modal } from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import { rendercomponent, rendersubcomponents } from "../libs/renderFunctions";
// import TextBox from "./TextBox"
// import DropDown from "./DropDown"
// import CheckBox from "./CheckBox"
// import LoadingPage from "./LoadingPage"
// import DatePicker from "./DatePicker"
// import DatePickerHTML from "./DatePickerHTML"
// import DateTimePickerHTML from "./DateTimePickerHTML"
// import NumberBox from "./NumberBox"
// import DataGrid from "./DataGrid"
// import AddressBox from "./AddressBox"
// import EntityLink from "./EntityLink"
// import MPANField from "./MPANField"
// import AgentField from "./AgentField"

export default class MessageResponseModal extends Component {
  constructor(props) {
    super(props);
    this.state=this.defaultState;
    this.initPage=this.initPage.bind(this);
    this.setDataValue=this.setDataValue.bind(this);
    this.setAddress=this.setAddress.bind(this);
    this.updateResponse=this.updateResponse.bind(this);
    this.showPage=this.showPage.bind(this)

  }
  defaultState={fields: [], fieldnames: [], fieldsValid: {}, formValid: true, responseDefinition: {'components': []}, messagedata: {}, activePage: 0, pageInitialised: false, fieldPageLookup: {}};

  async componentDidMount() {   
    
    this.setState(this.defaultState);
    this.initPage(this.props)
      
  }

  async componentWillReceiveProps(nextProps) {
    // this.setState(this.defaultState);    
    // console.log(nextProps)
    if (nextProps.visible && 'key' in nextProps.response && (nextProps.messageid!==this.props.messageid || nextProps.response.key!==this.props.response.key))
    {
      console.log(nextProps)
      this.initPage(nextProps)  
    }
    
  }

  
  async initPage (props) 
  {
    var newstate={}
    var formValid=true
    var fieldPageLookup={}
    //load message details if required
    var messagedata={}
    
    if ('sourcekey' in props.response)
    {
      console.log(this.props.messageid)
      if (this.props.messageid)
      {
        var result=await invokeApig({path: "/messages/"+this.props.messageid.toString(), method: "GET",  body: null});      
        messagedata=result.data.messagebody[props.response.sourcekey]
      }
    }
    newstate.messagedata=messagedata

    for (var i=0;i<props.response.fields.length;i++)
    {
      var component=props.response.fields[i];
      fieldPageLookup[component.fieldname]=this.props.response.pages.find((page)=>{return page.name===component.page});
      if(component['type']==='AddressBox')
      {
        var prefix='';
        prefix=component.fieldprefix;
        const addressFields=[prefix+'subbuildingname', prefix+'buildingname', prefix+'buildingnumber', prefix+'dependentthoroughfare', prefix+'thoroughfare', prefix+'doubledependentlocality', prefix+'dependentlocality', prefix+'posttown', prefix+'county', prefix+'postcode']
        addressFields.forEach((fieldname)=>{
            newstate[fieldname]='';
            newstate[fieldname+'_valid']=false;
            this.state.fieldnames.push(fieldname)
        })
        
      }
     else if (component.type=='TableInput' || component.type=='HiddenTableInput')
      {
        newstate[component.name]= messagedata[component.name];
        newstate[component.name+'_valid']=true;
        this.state.fieldnames.push(component.name);
      }      
      else if (component.type=='HiddenValue')
      {
        if ('value' in component)
        {
          newstate[component.fieldname]= component.value;
        }
        else if ('valuefield' in component)
        {
          newstate[component.fieldname]= messagedata[component.valuefield];
        }        
        else if ('fieldname' in component)
        {
          newstate[component.fieldname]= messagedata[component.fieldname];
        }

        newstate[component.fieldname+'_valid']=true
        this.state.fieldnames.push(component.fieldname);
      }
      else if (component.type=='MPANCombination')
      {
        newstate['profileclassid']= null;
        newstate['metertimeswitchcode']= null;
        newstate['linelossfactorclassid']= null;
        newstate['standardsettlementconfigurationid']= null;
        newstate['profileclassid_valid']= true;
        newstate['metertimeswitchcode_valid']= true;
        newstate['linelossfactorclassid_valid']= true;
        newstate['standardsettlementconfigurationid_valid']= true;


        this.state.fieldnames.push('profileclassid');
        this.state.fieldnames.push('metertimeswitchcode');
        this.state.fieldnames.push('linelossfactorclassid');
        this.state.fieldnames.push('standardsettlementconfigurationid');
      }      
      else
      {
        var fieldvalid
        if (component.fieldname in messagedata)
        {
          newstate[component.fieldname]= messagedata[component.fieldname];
          fieldvalid=true
        }
        else
        {
          newstate[component.fieldname]= null;
          if ('nullable' in component.field)
            fieldvalid=component.field.nullable;
          else 
          fieldvalid=true
        }
        newstate[component.fieldname+'_valid']=fieldvalid;
        formValid=formValid && fieldvalid;
        this.state.fieldnames.push(component.fieldname);
      }          
    }
    newstate.fieldPageLookup=fieldPageLookup;
    newstate.formValid=formValid;
    newstate.pageInitialised=true
    this.setState(newstate);
}
updateResponse= event => {
  event.preventDefault();

  //create json object with form data
  var responseData={}
  var field;
  for(var i = 0; i<this.state.fieldnames.length; i++)
  {
    field=this.state.fieldnames[i];
    responseData[field]=this.state[field]
  }
  console.log(JSON.stringify(responseData))
  this.props.postresponse(this.props.response.key, responseData)
  this.props.closeresponsemodal()
}

closeButtonClicked=()=>{this.props.closeresponsemodal()}


  setDataValue=(fieldname, field, value, valid=true)=>  {

    // set data
    this.setState({[fieldname]: value, [fieldname+'_valid']: valid});

    // update valid fields
    const formValid=this.state.fieldnames.filter(fieldname=>{return this.showPage(this.state.fieldPageLookup[fieldname])}).reduce((accumulator, currentvalue)=>{return accumulator && ((currentvalue===fieldname) ? valid : this.state[currentvalue.concat('_valid')])}, true);
    this.setState({formValid: formValid})
  }

  setAddress(subbuildingname, buildingname, buildingnumber, dependentthoroughfare, thoroughfare, doubledependentlocality, dependentlocality, posttown, county, postcode, fieldprefix='', valid=true)
  {
    // set data
    this.setState({
      [fieldprefix+'subbuildingname']: subbuildingname, 
      [fieldprefix+'buildingname']: buildingname, 
      [fieldprefix+'buildingnumber']: buildingnumber, 
      [fieldprefix+'dependentthoroughfare']: dependentthoroughfare, 
      [fieldprefix+'thoroughfare']: thoroughfare, 
      [fieldprefix+'doubledependentlocality']: doubledependentlocality, 
      [fieldprefix+'dependentlocality']: dependentlocality, 
      [fieldprefix+'posttown']: posttown, 
      [fieldprefix+'county']: county, 
      [fieldprefix+'postcode']: postcode, 
      [fieldprefix+'subbuildingname_valid']: valid, 
      [fieldprefix+'buildingname_valid']: valid, 
      [fieldprefix+'buildingnumber_valid']: valid, 
      [fieldprefix+'dependentthoroughfare_valid']: valid, 
      [fieldprefix+'thoroughfare_valid']: valid, 
      [fieldprefix+'doubledependentlocality_valid']: valid, 
      [fieldprefix+'dependentlocality_valid']: valid, 
      [fieldprefix+'posttown_valid']: valid, 
      [fieldprefix+'county_valid']: valid, 
      [fieldprefix+'postcode_valid']: valid,       
    });
  }

  showPage(page)
  {
    if (page)
      if ('showfield' in page)
      {
        //only show page if showfield=true
        if (this.state[page.showfield])
        return true
        else
        return false
    }
    else 
    return true
    else
    return false

  }

  render() {
    var activePages=[];
    var pagecomponents={};
    if ('pages' in this.props.response)
    {
      activePages=this.props.response.pages.filter(this.showPage);
      if (activePages.length>0)
      pagecomponents={components: this.props.response.fields.filter(component=>{return component.page===activePages[this.state.activePage].name})};
    }
     
    
    // const responsedef={components: this.props.response.fields}
    return (
     
        <Modal open={this.props.visible} size={'size' in this.props ? this.props.size : 'small'}>
        <Modal.Header>
        <h3><Icon circular className="seaglassblue" name={this.props.response.icon}/>{this.props.response.text}</h3>
        </Modal.Header>  
        <Modal.Content>
        <Step.Group size='mini' widths={activePages.length}>
        {activePages.map((page, i)=>
        {return  <Step active={this.state.activePage===i}><Icon name={page.icon} /><Step.Content><Step.Title as='h3'>{page.name}</Step.Title>
        </Step.Content>
        </Step>
        })}
        </Step.Group>
        <Form>
        {this.state.pageInitialised && rendersubcomponents(pagecomponents, this.state, this.setDataValue, this.setAddress, [], this.state.messagedata)}
        <Button className="seaglassbutton" disabled={this.state.activePage===0}  onClick={()=>{this.setState({activePage: this.state.activePage-1})}}>Previous</Button>
        <Button className="seaglassbutton" disabled={this.state.activePage>=activePages.length-1} onClick={()=>{this.setState({activePage: this.state.activePage+1})}}>Next</Button>
        <Button className="seaglassbutton" disabled={!this.state.formValid} onClick={this.updateResponse}>Respond</Button>
        <Button className="seaglassbutton" onClick={this.closeButtonClicked}>Cancel</Button>
        </Form>
        </Modal.Content>
        </Modal>   
      
    );
  }
}